module.exports = __webpack_public_path__ + "img/home-banner-text.4e240ba3.png";